var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFinance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-New_Finance_Item"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "New_Finance_Item",
    "data-name": "New Finance Item",
    clipPath: "url(#clip-New_Finance_Item)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "money_2_",
    "data-name": "money (2)",
    transform: "translate(-63.026 -63.596)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_19958",
    "data-name": "Path 19958",
    d: "M76.662,82.656h-.846a.968.968,0,0,0-.135-.03,5.47,5.47,0,0,1-1.552-.369A5.842,5.842,0,0,1,71.722,80.5a.255.255,0,0,0-.183-.087c-.339.025-.676.079-1.015.1A9.487,9.487,0,0,1,66.31,79.9,3.308,3.308,0,0,1,64,77.613V67.528a2.519,2.519,0,0,1,.808-1.388,5.071,5.071,0,0,1,1.782-1.005,10.312,10.312,0,0,1,5.678-.265,5.929,5.929,0,0,1,2.452,1.1,2.4,2.4,0,0,1,1,2.052c-.029.939-.007,1.88-.007,2.82v.2a5.748,5.748,0,0,1,1.7.1,5.817,5.817,0,0,1,.386,11.3C77.428,82.538,77.041,82.584,76.662,82.656Zm-5.184-5.822a4.761,4.761,0,1,0,4.774-4.757A4.77,4.77,0,0,0,71.477,76.833Zm-1.51-11.177a9.116,9.116,0,0,0-2.989.463,3.845,3.845,0,0,0-1.568.913A.958.958,0,0,0,65.4,68.51a.865.865,0,0,0,.166.157,7.044,7.044,0,0,0,1.042.613,9,9,0,0,0,5.923.23,3.9,3.9,0,0,0,1.715-.933.987.987,0,0,0,0-1.593,4.021,4.021,0,0,0-.956-.646A7.776,7.776,0,0,0,69.967,65.656ZM65.058,69.63c0,.415.018.8,0,1.187a1.177,1.177,0,0,0,.5,1.07,6.139,6.139,0,0,0,1.065.64,7.084,7.084,0,0,0,2.246.553,9.5,9.5,0,0,0,2.961-.142A.364.364,0,0,0,72,72.846a5.825,5.825,0,0,1,2.53-1.57c.105-.032.119-.085.118-.177,0-.441,0-.881,0-1.322,0-.037-.007-.074-.011-.121C72.31,71.391,67.41,71.362,65.058,69.63Zm6.028,4.5a10.9,10.9,0,0,1-3.134-.109,7.063,7.063,0,0,1-2.894-1.151c0,.4.016.768,0,1.134a1.149,1.149,0,0,0,.467,1.031,5.56,5.56,0,0,0,1.026.636,7.978,7.978,0,0,0,3.154.636c.245.006.49,0,.741,0A6.024,6.024,0,0,1,71.086,74.128Zm-6.028,1.925c0,.4.016.768,0,1.137a1.128,1.128,0,0,0,.451,1,5.221,5.221,0,0,0,1.039.649,8.475,8.475,0,0,0,3.946.621c.172-.009.343-.03.534-.047a5.976,5.976,0,0,1-.582-2.051A8.977,8.977,0,0,1,65.058,76.053Z",
    fill: "#0072ce",
    stroke: "#0072ce",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19959",
    "data-name": "Path 19959",
    d: "M291.164,247.27v-1.13h1.056c0,.324,0,.645,0,.966a.214.214,0,0,0,.146.234,1.552,1.552,0,0,1,.905,1.257,1.245,1.245,0,0,1,0,.162h-1.034c-.012-.042-.024-.086-.038-.13a.533.533,0,0,0-.6-.379.538.538,0,0,0-.437.559.527.527,0,0,0,.511.489,1.616,1.616,0,0,1,.9.273,1.583,1.583,0,0,1-.2,2.747.216.216,0,0,0-.151.231c.01.317,0,.634,0,.965h-1.058c0-.328-.005-.655,0-.981a.191.191,0,0,0-.134-.208,1.56,1.56,0,0,1-.916-1.25,1.278,1.278,0,0,1,0-.179h1.033c.011.039.022.083.035.125a.533.533,0,0,0,.591.389.539.539,0,0,0,.445-.552.527.527,0,0,0-.522-.5,1.588,1.588,0,0,1-.707-3.009C291.043,247.327,291.1,247.3,291.164,247.27Z",
    transform: "translate(-215.453 -172.994)",
    fill: "#0072ce"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFinance);
export default __webpack_public_path__ + "static/media/Finance.b24eec0b153c617ca405eb49cce76d95.svg";
export { ForwardRef as ReactComponent };